import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { SectionWiseModel } from "../../model-paper/entities/section-wise-model.entity";
import { QuestionPapers } from "./question-papers";

@Entity('section_question_mapping')
export class SectionQuestionMappingEntity {
    @PrimaryGeneratedColumn({ type: "int", name: "id" })
    id: number;

    @Column("int", { name: "chapter" })
    chapter: number;

    @Column("int", { name: "class" })
    class: number;

    @Column("int", { name: "no_of_qns" })
    noOfQns: number;

    @Column("int", { name: "difficulty_level", nullable: true })
    difficultyLevel: number;

    @Column("int", { name: "language" })
    language: number;

    @Column("int", { name: "question_type", nullable: true })
    questionType: number;

    @Column("int", { name: "subject" })
    subject: number;

    @Column("int", { name: "topic", nullable: true })
    topic: number;

    @Column("int", { name: "weightage" })
    weightage: number;

    @Column("text", { name: "qno_s" })
    qnos: string;

    @ManyToOne(() => SectionWiseModel, (qnpModel) => qnpModel.sectionsQuestionMapping)
    @JoinColumn({ name: 'section' })
    section: SectionWiseModel

    @ManyToOne(() => QuestionPapers, (qnp) => qnp.sectionsQuestionMapping)
    @JoinColumn({ name: 'question_paper' })
    questionPaper: QuestionPapers
}
